module.exports = __webpack_public_path__ + "img/W-S68.a3c8b441.jpg";